import React from 'react';

import { useIntl } from 'react-intl-next';

import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import { ButtonMenuItem } from '@atlaskit/navigation-system';
import { token } from '@atlaskit/tokens';

import type { NavItemVisibilityToggleProps } from '../../../types';

import messages from './messages';

export function NavItemVisibilityToggle({
	TriggerComponent = ButtonMenuItem,
	isVisible,
	toggleVisibility,
}: NavItemVisibilityToggleProps): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<TriggerComponent
			onClick={toggleVisibility}
			elemBefore={
				isVisible ? (
					<EyeOpenStrikethroughIcon
						label=""
						color={token('color.icon')}
						testId="eye-strikethrough-icon"
					/>
				) : (
					<EyeOpenIcon label="" color={token('color.icon')} testId="eye-open-icon" />
				)
			}
		>
			{isVisible ? formatMessage(messages.hideItem) : formatMessage(messages.showItem)}
		</TriggerComponent>
	);
}
